
import { NgModule } from '@angular/core';

import { StandardTableListProvider } from './standard-table-list.provider';
import { StandardTableEditProvider } from './standard-table-edit.provider';

export * from './standard-table-list.provider';
export * from './standard-table-edit.provider';

export {
  StandardTableListProvider,
  StandardTableEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    StandardTableEditProvider,
    StandardTableListProvider
  ]
})
export class StandardTableBackendModule { }
